import { OlxAvailablePackage } from '../../../../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import {
  AVAILABLE_PACKAGE_TYPES,
  AvailablePackageType,
  NormalizedAvailablePackages,
} from './buy-olx-packages-v2.interface';

export const toNormalizedType = (p: OlxAvailablePackage): AvailablePackageType => {
  if (p.type === 'mega') return AvailablePackageType.MEGA;
  return p.is_premium ? AvailablePackageType.PREMIUM : AvailablePackageType.BASE;
};

export const normalizeAvailablePackages = (list: OlxAvailablePackage[]): NormalizedAvailablePackages => {
  const buckets: NormalizedAvailablePackages = { base: [], premium: [], mega: [] };

  for (const p of list) {
    const type = toNormalizedType(p);
    buckets[type].push(p);
  }

  AVAILABLE_PACKAGE_TYPES.forEach(t => {
    buckets[t].sort((a, b) => a.size - b.size);
  });

  return buckets;
};
